import { uuid4 } from '@sentry/utils';
import { isSampled } from '../util/isSampled.js';
/**
 * Get a session with defaults & applied sampling.
 */

function makeSession(session) {
  var now = new Date().getTime();
  var id = session.id || uuid4(); // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.

  var started = session.started || now;
  var lastActivity = session.lastActivity || now;
  var segmentId = session.segmentId || 0;
  var sampled = session.sampled;
  return {
    id: id,
    started: started,
    lastActivity: lastActivity,
    segmentId: segmentId,
    sampled: sampled
  };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */


function getSessionSampleType(sessionSampleRate, errorSampleRate) {
  return isSampled(sessionSampleRate) ? 'session' : isSampled(errorSampleRate) ? 'error' : false;
}

export { getSessionSampleType, makeSession };